import React from 'react';
import { GLUtils, GLCopyPipeline } from '@capture/gl-core';
import GradientCanvas from './GradientCanvas';
import ThumbsUpDown from "../components/ThumbsUpDown"
import DownloadTopPanel from "../components/DownloadTopPanel"
import Button from '@react/react-spectrum/Button';
import Header from "../components/headers/Header"
export default class GradientCoreExample extends React.Component {

    constructor(props) {
        super(props);
        this.overlayCanvas = React.createRef();
        this.gl = null;
        this.frameID = null;
        this.texture = null;
        this._updateDimensions = this._updateDimensions.bind(this)
        this.updateCanvasWidthHeight = this.updateCanvasWidthHeight.bind(this);
        this._getImageData = this._getImageData.bind(this);
        this._loadTexture = this._loadTexture.bind(this);
        this._draw = this._draw.bind(this);
        this.changeStopCount = this.changeStopCount.bind(this);
        this.state = {
            stopsCount: 3,
            markers: [],
            imageData: null,
            canavasWidth: 0,
            canvasHeight: 0
        }
    }
    componentDidMount() {
        let that = this;
        this._getImageData(this.props.image.image);
        this._loadTexture(this.props.image.image);
    }
    componentDidUpdate(prevprops,prevState){
        if (prevState.image !== this.state.image) {
            this._getImageData(this.state.image);
            this._loadTexture(this.state.image);
        }
    }
    _getImageData(imageURI) {
        let that = this;
        this.image = new Image();
        this.image.onload = function () {
            that.colorCanvas = document.createElement('canvas');
            that.colorCanvas.width = that.image.width;
            that.colorCanvas.height = that.image.height;
            const ctx = that.colorCanvas.getContext('2d');
            let width = that.colorCanvas.width;
            let height = that.colorCanvas.height;
            ctx.drawImage(that.image, 0, 0, width, height);
            that.imageData = ctx.getImageData(0, 0, width, height);
            that.setState({
                imageData: that.imageData
            })
            that.updateCanvasWidthHeight();
        };
        this.image.src = imageURI;
    }
    updateCanvasWidthHeight() {
        const canvas = this.overlayCanvas.current;
        if (canvas === null) {
            return;
        }
        const canvasWidth = canvas.getBoundingClientRect().width;
        const canvasHeight = canvas.getBoundingClientRect().height;
        this.setState({
            canvasWidth: canvasWidth,
            canvasHeight: canvasHeight
        })
    }
    _loadTexture(imageURI) {
        if (this.frameID) {
            cancelAnimationFrame(this.frameID);
        }
        // window.addEventListener('resize', this._updateDimensions);
        const canvas = this.overlayCanvas.current;
        this.gl = canvas.getContext('webgl');
        this.texture = GLUtils.loadTexture(this.gl, imageURI, (_, textureWidth, textureHeight) => {
            this.textureWidth = textureWidth;
            this.textureHeight = textureHeight;
            this._updateDimensions();
            this.frameID = requestAnimationFrame(this._draw);
        });
    }
    _updateDimensions() {
        var displayWidth = this.overlayCanvas.current.clientWidth;
        var displayHeight = this.overlayCanvas.current.clientHeight;
        if (this.overlayCanvas.current.width !== displayWidth || this.overlayCanvas.current.height !== displayHeight) {
            this.overlayCanvas.current.width = displayWidth;
            this.overlayCanvas.current.height = displayHeight;
        }
    }
    _draw() {
        if (this.gl) {
            const pipeline = GLCopyPipeline;
            pipeline.bind(this.gl);
            pipeline.setViewSize(this.gl, this.overlayCanvas.current.width, this.overlayCanvas.current.height);
            pipeline.setSize(this.gl, this.textureWidth, this.textureHeight);
            pipeline.draw(this.gl, this.texture);
            this.frameID = requestAnimationFrame(this._draw);
        }
    }
    changeStopCount(event) {
        const stopsCount = parseInt(event.target.value);
        this.setState({
            stopsCount: stopsCount
        })
    }
    handleUpload = (e) => {
        if (e.target.files && e.target.files[0]) {
            let img = e.target.files[0];
            let src = URL.createObjectURL(img);
            this.setState({
                image: src,
                loaded: true
            });
        }
    }
    download = ()  => {
        console.log(this.refs.gradientStrip)
    }
    render() {
        return (
            <>
            <div className="patternTheme">
                <div className="downloadedPanel">
                    <div className="firstDownloadPanel">
                        <DownloadTopPanel title={this.props.image.title} desc = {this.props.image.desc} />
                        <div className="downloadButtons">
                            <Button variant="cta" onClick={this.download}> Download </Button>
                            <input type="file" name="imgUpload" ref="file" className="inputfile" onChange={this.handleUpload}
                                accept=".png,.jpg"
                            />
                        <Button onClick = {() => this.refs.file.click()}>Add new</Button> 
                        </div>
                    </div>
                    <ThumbsUpDown title ={this.props.image.title} />
                </div>
                <div class ="patternCanvas">
                <canvas className="canvasPattern" ref={this.overlayCanvas} />
            
                <div className ="gradientButton">
                    <div className = "gradientStops">
                    <p style={{ float: "left" }}>Gradient Stops</p><p style={{ float: "right" }}>{this.state.stopsCount}</p>
                    <input type="range" min="0" max="10" value={this.state.stopsCount} onChange={this.changeStopCount} />
                    </div>
                    <div>
                    <GradientCanvas ref = "gradientStrip" imageData={this.imageData} stopsCount={this.state.stopsCount} canvasWidth={this.state.canvasWidth} canvasHeight={this.state.canvasHeight} />
                    </div>
                </div>
                </div>
            </div>
            </>);
    }
}